import { render, staticRenderFns } from "./CorporationMemberInvitationArea.vue?vue&type=template&id=0909e7f6&scoped=true&"
import script from "./CorporationMemberInvitationArea.vue?vue&type=script&lang=ts&"
export * from "./CorporationMemberInvitationArea.vue?vue&type=script&lang=ts&"
import style0 from "./CorporationMemberInvitationArea.vue?vue&type=style&index=0&id=0909e7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909e7f6",
  null
  
)

export default component.exports